<template>
  <main class="login-page">
    <div class="login-brand">
      <span class="login-mark"><app-icon name="building" /></span>
      <div>
        <strong>宜投地产</strong>
        <small>销售外勤工作台</small>
      </div>
    </div>
    <section class="login-card">
      <span class="focus-tag">今日</span>
      <h1>今天先联系谁，<br>打开就知道</h1>
      <p>到期客户按跟进时间排好，打完一位记一笔。</p>
    </section>
    <form @submit.prevent="login">
      <label class="field">
        <span>员工账号</span>
        <input v-model.trim="username" name="username" autocomplete="username" placeholder="请输入员工账号" required />
      </label>
      <label class="field">
        <span>登录密码</span>
        <input v-model="password" name="password" autocomplete="current-password" type="password" placeholder="请输入密码" required />
      </label>
      <p v-if="expired && !error" class="notice">登录已过期，请重新登录，跟进草稿已保留。</p>
      <p v-if="error" class="error-message" role="alert">{{ error }}</p>
      <button class="button full" type="submit" :disabled="busy">
        <span v-if="busy" class="spinner" />
        {{ busy ? '正在登录' : '登录' }}
        <app-icon v-if="!busy" name="arrow" />
      </button>
    </form>
    <p class="login-foot">宜投地产 · 新房 · 公寓 · 商铺</p>
  </main>
</template>
<script>
import { clearSession, employee } from '../common/session'
export default {
  data() {
    return {
      username: '',
      password: '',
      error: '',
      busy: false,
      expired: this.$route.query.expired === '1'
    }
  },
  methods: {
    async login() {
      if (this.busy) return
      this.busy = true
      this.error = ''
      try {
        clearSession(this.$store)
        const data = await this.$api.post('/api/authorizations', {
          username: this.username,
          password: this.password
        })
        if (!data.access_token) throw new Error('登录未返回有效凭证，请重试')
        localStorage.setItem('token', data.access_token)
        await employee(this.$store)
        const redirect = this.$route.query.redirect
        this.$router.replace(
          typeof redirect === 'string' &&
          redirect.charAt(0) === '/' &&
          redirect.slice(0, 2) !== '//' &&
          redirect !== '/'
            ? redirect
            : '/workbench'
        )
      } catch (e) {
        this.error = e.message
      } finally {
        this.busy = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login.vue